import React from 'react';
import { Button, Empty, Select, Tag } from 'antd';

const { Option } = Select;

export default function ProductPropertyLibrarySection(props) {
    const {
        properties = [],
        selectedPropertyNames = [],
        allProperties = [],
        onSelectedPropertyNamesChange,
        onSelectedPropertyValuesChange,
        onOpenPropertyLibrary,
        onOpenQuickGenerate
    } = props;

    return (
        <div style={{ marginBottom: 16, border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff' }}>
            <div className="d-flex justify-content-between align-items-center" style={{ padding: '16px 16px 8px' }}>
                <div>
                    <div style={{ fontSize: 28, fontWeight: 700, marginBottom: 4 }}>Thuộc tính variant</div>
                    <div style={{ color: '#6b7280' }}>Chọn thuộc tính từ thư viện để dùng cho tạo nhanh biến thể</div>
                </div>
                <Button type="primary" onClick={onOpenPropertyLibrary}>Quản lý thư viện</Button>
            </div>
            <div style={{ padding: '0 16px 16px' }}>
                <Select
                    mode="multiple"
                    style={{ width: '100%', marginBottom: 12 }}
                    placeholder="Chọn thuộc tính để tạo nhanh variant"
                    value={selectedPropertyNames}
                    onChange={onSelectedPropertyNamesChange}
                    optionFilterProp="children"
                >
                    {allProperties.map((item) => <Option key={item._id || item.name} value={item.name}>{item.name}</Option>)}
                </Select>
                {properties.length > 0 ? (
                    <div style={{ display: 'grid', gap: 12 }}>
                        {properties.map((property) => (
                            <div
                                key={property._id || property.name}
                                style={{ border: '1px solid #e5e7eb', borderRadius: 10, padding: 12, background: '#fafafa' }}
                            >
                                <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: 8, gap: 12 }}>
                                    <div style={{ fontWeight: 600, fontSize: 16 }}>{property.name}</div>
                                    <Tag color="blue">{property.values ? property.values.length : 0} giá trị đang dùng</Tag>
                                </div>
                                <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder={`Chọn giá trị dùng để tạo variant cho ${property.name}`}
                                    value={property.values || []}
                                    onChange={(values) => onSelectedPropertyValuesChange(property.name, values)}
                                    optionFilterProp="children"
                                >
                                    {(property.allValues || property.values || []).map((value) => (
                                        <Option key={`${property.name}-${value}`} value={value}>{value}</Option>
                                    ))}
                                </Select>
                                <div style={{ color: '#6b7280', marginTop: 8 }}>
                                    Bỏ bớt giá trị không cần để tránh tạo dư biến thể.
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="Chưa chọn thuộc tính nào cho tạo nhanh variant"
                    />
                )}
                <div className="d-flex justify-content-end" style={{ marginTop: 12, gap: 8 }}>
                    <Button onClick={onOpenPropertyLibrary}>Quản lý thư viện</Button>
                    <Button type="primary" onClick={onOpenQuickGenerate}>⚡ Tạo nhanh</Button>
                </div>
            </div>
        </div>
    );
}
